import { createElement } from "react";
import styled from "styled-components";


export const StyledTypography = styled(({tag, children, ...props}) => createElement(tag, props, children))`
    /**
     *  need to write css if any thing want 
     * /
`